<template>
  <!--
      作者：kmdshop
      描述：文件管理 / 图片上传
  -->
  <div class="upload-wrap">

    <el-dialog
      title="文件管理"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="upload-dialog"
      :width="dialogWidth"
    
      :append-to-body="true"
      style="margin-top:-7%;"
      @close="cancelFunc"
    >

      <!-- ===================================================== -->
      <!-- 顶部工具栏 -->
      <!-- ===================================================== -->
      <div class="file-toolbar">

        <!-- 左侧操作 -->
        <div class="toolbar-left">

          <!-- 添加分类 -->
          <el-button
            size="small"
            icon="el-icon-folder-add"
            @click="addCategory"
          >
            添加分类
          </el-button>


          <!-- 全选 -->
          <el-button
            size="small"
            :type="isAllSelected ? 'warning' : 'primary'"
      
            plain
            @click="selectAllFunc"
          >
            {{ isAllSelected ? '取消全选' : '全选当前页' }}
          </el-button>


          <!-- 已选数量 -->
          <div class="selected-count">
            已选
            <span>{{ selectedCount }}</span>
            个
          </div>


          <!-- 移动 -->
          <el-popover
            placement="bottom"
            width="200"
            trigger="click"
          >
            <div class="move-title">
              移动到分类
            </div>

            <ul class="move-type">

              <li
                v-for="(item,index) in typeList"
                :key="index"
                @click="moveTypeFunc(item.group_id)"
              >
                <i class="el-icon-folder"></i>

                {{ item.group_name }}
              </li>

            </ul>

            <el-button
              slot="reference"
              size="small"
              icon="el-icon-sort"
            >
              移动至
            </el-button>

          </el-popover>


          <!-- 批量删除 -->
          <el-button
            size="small"
            type="danger"
            plain
            icon="el-icon-delete"
            @click="deleteFileFunc(false)"
          >
            批量删除
          </el-button>

        </div>


        <!-- 右侧上传 -->
        <div class="toolbar-right">

          <el-upload
            ref="upload"
            class="avatar-uploader"
            multiple
            action="string"
            :before-upload="onBeforeUploadImage"
            :http-request="UploadImage"
            :show-file-list="false"
            :on-change="fileChange"
          >

            <el-button
              size="small"
              icon="el-icon-upload2"
              type="primary"
            >
              上传文件
            </el-button>

          </el-upload>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- 搜索区域 -->
      <!-- ===================================================== -->
      <div class="search-bar">

        <div class="search-item type-select">

          <el-select
            v-model="selectType"
            placeholder="文件类型"
            clearable
            @change="searchFunc"
          >

            <el-option
              label="全部类型"
              value=""
            />

            <el-option
              label="图片"
              value="image"
            />

            <el-option
              label="视频"
              value="video"
            />

          </el-select>

        </div>


        <div class="search-item search-input">

          <el-input
            v-model="real_name"
            placeholder="请输入文件名称"
            clearable
            prefix-icon="el-icon-search"
            @keyup.enter.native="searchFunc"
            @clear="searchFunc"
          />

        </div>


        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="searchFunc"
        >
          查询
        </el-button>


        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetSearch"
        >
          重置
        </el-button>

      </div>


      <!-- ===================================================== -->
      <!-- 资源库 -->
      <!-- ===================================================== -->
      <div class="file-container">

        <!-- 左侧分类 -->
        <div class="file-type">

          <div class="category-title">
            文件分类
          </div>

          <ul>

            <li
              v-for="(item,index) in typeList"
              :key="index"
              :class="[
                'category-item',
                activeType == item.group_id ? 'active' : ''
              ]"
              @click="selectTypeFunc(item.group_id)"
            >

              <div class="category-name">

                <i
                  :class="
                    activeType == item.group_id
                    ? 'el-icon-folder-opened'
                    : 'el-icon-folder'
                  "
                ></i>

                <span>{{ item.group_name }}</span>

              </div>


              <!-- 分类编辑 -->
              <div
                v-if="item.group_id != null"
                class="operation"
                @click.stop
              >

                <i
                  class="el-icon-edit"
                  title="编辑"
                  @click="editCategoryFunc(item)"
                ></i>

                <i
                  class="el-icon-delete"
                  title="删除"
                  @click="deleteCategoryFunc(item.group_id)"
                ></i>

              </div>

            </li>

          </ul>

        </div>


        <!-- 右侧文件 -->
        <div class="file-content">

          <!-- 加载 -->
          <div
            v-if="loading"
            class="loading-box"
          >

            <i class="el-icon-loading"></i>

            <span>正在加载...</span>

          </div>


          <!-- 有数据 -->
          <ul
            v-else-if="
              fileList &&
              fileList.data &&
              fileList.data.length > 0
            "
            class="file-list clearfix"
          >

            <li
              v-for="(item,index) in fileList.data"
              :key="item.file_id || index"
              :class="[
                'file-card',
                item.selected ? 'selected' : ''
              ]"
              :title="item.real_name"
              @click="selectFileFunc(item,index)"
            >

              <!-- 选中角标 -->
              <div
                v-if="item.selected"
                class="selected-icon"
              >

                <i class="el-icon-check"></i>

              </div>


              <!-- 文件预览区域 -->
              <div class="file-preview">

                <!-- 图片 -->
                <el-image
                  v-if="item.file_type == 'image'"
                  class="preview-image"
                  :src="item.file_path"
                  fit="cover"
                  lazy
                >

                  <div
                    slot="error"
                    class="image-error"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>

                </el-image>


                <!-- 视频 -->
                <video
                  v-else-if="item.file_type == 'video'"
                  class="preview-video"
                  :src="item.file_path"
                ></video>


                <!-- 文档 -->
                <div
                  v-else-if="
                    documentArr.indexOf(item.extension) >= 0
                  "
                  class="document-preview"
                >

                  <i class="el-icon-document"></i>

                  <span>
                    {{ item.extension }}
                  </span>

                </div>


                <!-- 其他文件 -->
                <div
                  v-else
                  class="document-preview"
                >

                  <i class="el-icon-files"></i>

                  <span>
                    {{ item.extension || 'FILE' }}
                  </span>

                </div>

              </div>


              <!-- 文件名 -->
              <div class="file-info">

                <p class="file-name">
                  {{ item.real_name || '未命名文件' }}
                </p>

              </div>


              <!-- 删除 -->
              <div
                class="file-actions"
                @click.stop
              >

                <el-tooltip
                  content="删除文件"
                  placement="top"
                >

                  <div
                    class="delete-btn"
                    @click="deleteFileFunc(item)"
                  >

                    <i class="el-icon-delete"></i>

                  </div>

                </el-tooltip>

              </div>

            </li>

          </ul>


          <!-- 空 -->
          <div
            v-else
            class="empty-box"
          >

            <div class="empty-icon">

              <i class="el-icon-picture-outline"></i>

            </div>

            <div class="empty-title">
              暂无文件
            </div>

            <div class="empty-desc">
              点击右上角“上传文件”添加资源
            </div>

          </div>

        </div>

      </div>


      <!-- ===================================================== -->
      <!-- 分页 -->
      <!-- ===================================================== -->
      <div class="pagination-wrap">

        <div class="pagination-info">

          当前页
          <span>
            {{
              fileList &&
              fileList.data
              ? fileList.data.length
              : 0
            }}
          </span>
          个文件

        </div>


        <el-pagination
          :current-page="curPage"
          :page-sizes="[12,24,36,48,60,120,240,360]"
          :page-size="pageSize"
          :total="totalDataNumber"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />

      </div>


      <!-- ===================================================== -->
      <!-- 底部 -->
      <!-- ===================================================== -->
      <div
        slot="footer"
        class="dialog-footer"
      >

        <div class="footer-left">

          <span>
            已选择
          </span>

          <strong>
            {{ selectedCount }}
          </strong>

          <span>
            个文件
          </span>


          <template v-if="Number(this_config.total) > 0">

            <span class="limit-text">
              最多可选择 {{ this_config.total }} 个
            </span>

          </template>


          <template v-else>

            <span class="limit-text">
              不限制选择数量
            </span>

          </template>

        </div>


        <div>

          <el-button
            size="small"
            @click="cancelFunc"
          >
            取消
          </el-button>

          <el-button
            size="small"
            type="primary"
            :disabled="selectedCount === 0"
            @click="confirmFunc"
          >
            确定选择
            <template v-if="selectedCount">
              （{{ selectedCount }}）
            </template>
          </el-button>

        </div>

      </div>

    </el-dialog>


    <!-- 图片类别 -->
    <AddCategory
      v-if="isShowCategory"
      :category="category"
      @closeCategory="closeCategoryFunc"
    />

  </div>
</template>


<script>
import FileApi from '@/api/file.js'
import AddCategory from './part/AddCategory'

export default {

  components: {
    AddCategory
  },


  props: [
    'config',
    'type'
  ],


  data() {

    return {

      documentArr: [
        'doc',
        'docx',
        'ppt',
        'pptx',
        'xls',
        'xlsx',
        'pdf'
      ],

      /* 弹窗宽度 */
      dialogWidth: '1200px',

      /* 当前分类 */
      activeType: null,

      /* 分类列表 */
      typeList: [],

      imageUrl: null,

      /* 弹窗 */
      dialogVisible: true,

      /* 文件列表 */
      fileList: {
        data: [],
        total: 0
      },

      /* 默认配置 */
      this_config: {

        /**
         * total:
         *
         * 1 = 只能选择1个
         * 9 = 最多9个
         * 0 = 不限制
         */
        total: 1

      },

      /* 已选数量 */
      record: 0,

      /* 加载 */
      loading: true,

      tableData: [],

      /* 每页 */
      pageSize: 36,

      /* 总数量 */
      totalDataNumber: 0,

      /* 页码 */
      curPage: 1,

      /* 分类弹窗 */
      isShowCategory: false,

      /* 当前编辑分类 */
      category: null,

      /* 文件id */
      fileIds: [],

      /* 文件类型 */
      selectType: '',

      /* 名称 */
      real_name: ''

    }

  },


  computed: {

    /**
     * 当前页是否全部选中
     */
    isAllSelected() {

      if (
        !this.fileList ||
        !this.fileList.data ||
        this.fileList.data.length === 0
      ) {
        return false
      }

      return this.fileList.data.every(
        item => item.selected === true
      )

    },


    /**
     * 当前页选中数量
     */
    selectedCount() {

      if (
        !this.fileList ||
        !this.fileList.data
      ) {
        return 0
      }

      return this.fileList.data.filter(
        item => item.selected === true
      ).length

    }

  },


  created() {

    /**
     * 覆盖默认配置
     */
    if (
      Object.prototype
        .toString
        .call(this.config)
        .toLowerCase() === '[object object]'
    ) {

      for (let key in this.config) {

        this.this_config[key] =
          this.config[key]

      }

    }


    this.getFileCategory()

    this.getData()

  },


  methods: {

    /**
     * =========================================
     * 获取分类
     * =========================================
     */
    getFileCategory() {

      let self = this

      let param = {}

      FileApi.fileCategory(
        param,
        true
      )
        .then(data => {

          let type = [
            {
              group_id: null,
              group_name: '全部文件'
            }
          ]

          self.typeList =
            type.concat(
              data.data.group_list || []
            )

        })
        .catch(() => {

          self.loading = false

        })

    },


    /**
     * 添加分类
     */
    addCategory() {

      this.category = null

      this.isShowCategory = true

    },


    /**
     * 编辑分类
     */
    editCategoryFunc(item) {

      this.category = item

      this.isShowCategory = true

    },


    /**
     * 关闭分类
     */
    closeCategoryFunc(e) {

      if (e != null) {

        this.getFileCategory()

      }

      this.isShowCategory = false

    },


    /**
     * 删除分类
     */
    deleteCategoryFunc(e) {

      this.$confirm(
        '删除分类后不可恢复，是否继续？',
        '删除分类',
        {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {

          this.deleteCategory(e)

        })
        .catch(() => {})

    },


    deleteCategory(e) {

      let self = this

      FileApi.deleteCategory({
        group_id: e
      })
        .then(() => {

          self.$message({
            message: '分类删除成功',
            type: 'success'
          })

          self.getFileCategory()

          if (self.activeType === e) {

            self.activeType = null

            self.getData()

          }

        })
        .catch(() => {

          self.$message.error(
            '分类删除失败'
          )

        })

    },


    /**
     * =========================================
     * 选择分类
     * =========================================
     */
    selectTypeFunc(id) {

      this.activeType = id

      this.curPage = 1

      this.record = 0

      this.getData()

    },


    /**
     * 分页
     */
    handleCurrentChange(val) {

      this.curPage = val

      this.record = 0

      this.getData()

    },


    /**
     * 每页数量
     */
    handleSizeChange(val) {

      this.curPage = 1

      this.pageSize = val

      this.record = 0

      this.getData()

    },


    /**
     * 查询
     */
    searchFunc() {

      this.curPage = 1

      this.record = 0

      this.getData()

    },


    /**
     * 重置
     */
    resetSearch() {

      this.selectType = ''

      this.real_name = ''

      this.curPage = 1

      this.getData()

    },


    /**
     * =========================================
     * 获取文件
     * =========================================
     */
    getData() {

      let self = this

      self.loading = true

      let param = {

        type: self.type,

        real_name:
          self.real_name,

        fileType:
          self.selectType,

        page:
          self.curPage,

        pageSize:
          self.pageSize,

        group_id:
          self.activeType

      }


      FileApi.fileList(
        param,
        true
      )
        .then(data => {

          self.loading = false

          self.fileList =
            data.data.file_list || {
              data: [],
              total: 0
            }


          if (
            !self.fileList.data
          ) {

            self.$set(
              self.fileList,
              'data',
              []
            )

          }


          /**
           * 保证selected字段存在
           */
          self.fileList.data.forEach(
            (item,index) => {

              if (
                typeof item.selected ===
                'undefined'
              ) {

                self.$set(
                  item,
                  'selected',
                  false
                )

              }

              self.$set(
                self.fileList.data,
                index,
                item
              )

            }
          )


          self.totalDataNumber =
            Number(
              self.fileList.total || 0
            )


          self.record = 0

        })
        .catch(() => {

          self.loading = false

        })

    },


    /**
     * =========================================
     * 全选 / 取消全选
     * =========================================
     */
    selectAllFunc() {

      if (
        !this.fileList ||
        !this.fileList.data ||
        this.fileList.data.length === 0
      ) {

        this.$message({
          message: '当前暂无文件',
          type: 'warning'
        })

        return

      }


      /**
       * 当前已全选
       * 再点就是取消全选
       */
      if (this.isAllSelected) {

        this.fileList.data.forEach(
          (item,index) => {

            item.selected = false

            this.$set(
              this.fileList.data,
              index,
              item
            )

          }
        )

        this.record = 0

        return

      }


      /**
       * 最大数量
       *
       * total = 0 不限制
       */
      const maxTotal = 0
      


      /**
       * 不限制
       */
      if (maxTotal <= 0) {

        this.fileList.data.forEach(
          (item,index) => {

            item.selected = true

            this.$set(
              this.fileList.data,
              index,
              item
            )

          }
        )

        this.record =
          this.fileList.data.length

        return

      }


      /**
       * 有最大数量限制
       *
       * 例如：
       * total = 9
       *
       * 当前页36个
       * 只选前9个
       */
      let count = 0


      this.fileList.data.forEach(
        (item,index) => {

          if (count < maxTotal) {

            item.selected = true

            count++

          } else {

            item.selected = false

          }


          this.$set(
            this.fileList.data,
            index,
            item
          )

        }
      )


      this.record = count


      /**
       * 当前页超过限制
       */
      if (
        this.fileList.data.length >
        maxTotal
      ) {

        this.$message({
          message:
            '当前最多可选择 ' +
            maxTotal +
            ' 个文件',
          type: 'warning'
        })

      }

    },


    /**
     * =========================================
     * 单个选择
     * =========================================
     */
    selectFileFunc(
      item,
      index
    ) {

      /**
       * 取消
       */
      if (item.selected) {

        item.selected = false

        this.record = Math.max(
          0,
          this.record - 1
        )


        this.$set(
          this.fileList.data,
          index,
          item
        )

        return

      }


      /**
       * 最大选择数量
       */
      const maxTotal =
        Number(
          this.this_config.total || 0
        )


      /**
       * total > 0
       * 才限制
       */
      if (
        maxTotal > 0 &&
        this.selectedCount >= maxTotal
      ) {

        this.$message({
          message:
            '本次最多只能选择 ' +
            maxTotal +
            ' 个文件',
          type: 'warning'
        })

        return

      }


      item.selected = true

      this.record++


      this.$set(
        this.fileList.data,
        index,
        item
      )

    },


    /**
     * =========================================
     * 移动文件
     * =========================================
     */
    moveTypeFunc(e) {

      let self = this

      let fileIds = []


      self.fileList.data.forEach(
        item => {

          if (item.selected) {

            fileIds.push(
              item.file_id
            )

          }

        }
      )


      if (
        fileIds.length === 0
      ) {

        self.$message({
          message: '请先选择需要移动的文件',
          type: 'warning'
        })

        return

      }


      self.$confirm(
        '确定将选中的 ' +
        fileIds.length +
        ' 个文件移动到该分类吗？',
        '移动文件',
        {
          confirmButtonText: '确定移动',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {

          FileApi.moveFile(
            {
              group_id: e,
              fileIds: fileIds
            },
            true
          )
            .then(() => {

              self.$message({
                message: '移动成功',
                type: 'success'
              })

              self.getFileCategory()

              self.getData()

            })

        })
        .catch(() => {})

    },


    /**
     * =========================================
     * 文件上传
     * =========================================
     */
    fileChange(e) {

      console.log(e)

    },


    /**
     * 上传之前校验
     */
    onBeforeUploadImage(file) {

      /**
       * 支持图片 / 视频 / 文档
       *
       * 如果你只允许图片，
       * 可以自行缩减这里
       */
      const allowTypes = [

        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',

        'video/mp4',
         'video/mov',
         'video/quicktime',
        'application/pdf',

        'application/msword',

        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

        'application/vnd.ms-excel',

        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

      ]


      const isAllow =
        allowTypes.indexOf(
          file.type
        ) !== -1


      /**
       * 200MB
       */
      const isLt200M =
        file.size /
        1024 /
        1024 <
        200


      if (!isAllow) {

        this.$message.error(
          '暂不支持该文件格式'
        )

        return false

      }


      if (!isLt200M) {

        this.$message.error(
          '文件大小不能超过200MB'
        )

        return false

      }


      return true

    },


    /**
     * 上传
     */
    UploadImage(param) {

      let self = this


      const loading =
        this.$loading({

          lock: true,

          text: '文件上传中，请稍候...',

          spinner:
            'el-icon-loading',

          background:
            'rgba(0,0,0,.65)'

        })


      const formData =
        new FormData()


      formData.append(
        'iFile',
        param.file
      )


      if (
        self.activeType !==
        null
      ) {

        formData.append(
          'group_id',
          self.activeType
        )

      }


      FileApi.uploadFile(
        formData
      )
        .then(() => {

          loading.close()

          self.$message({
            message: '上传成功',
            type: 'success'
          })

          self.getData()

          param.onSuccess()

        })
        .catch(() => {

          loading.close()

          self.$message({
            message: '文件上传失败',
            type: 'warning'
          })

          param.onError()

        })

    },


    /**
     * =========================================
     * 删除文件
     * =========================================
     */
    deleteFileFunc(e) {

      let self = this

      let temp_list = []


      /**
       * 单文件
       */
      if (e) {

        temp_list.push(
          e.file_id
        )

      }

      /**
       * 批量
       */
      else {

        self.fileList.data.forEach(
          item => {

            if (item.selected) {

              temp_list.push(
                item.file_id
              )

            }

          }
        )

      }


      /**
       * 没选
       */
      if (
        temp_list.length === 0
      ) {

        self.$message({
          message: '请先选择需要删除的文件',
          type: 'warning'
        })

        return

      }


      self.$confirm(
        '确定删除选中的 ' +
        temp_list.length +
        ' 个文件吗？删除后不可恢复。',
        '删除文件',
        {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {

          const loading =
            self.$loading({

              lock: true,

              text: '正在删除...',

              spinner:
                'el-icon-loading',

              background:
                'rgba(0,0,0,.65)'

            })


          FileApi.deleteFiles(
            {
              fileIds:
                temp_list
            },
            true
          )
            .then(() => {

              loading.close()

              self.$message({
                message: '删除成功',
                type: 'success'
              })

              self.record = 0

              self.getData()

            })
            .catch(() => {

              loading.close()

              self.$message({
                message: '删除失败',
                type: 'warning'
              })

            })

        })
        .catch(() => {})

    },


    /**
     * =========================================
     * 确认选择
     * =========================================
     */
    confirmFunc() {

      let list = []


      const maxTotal =
        Number(
          this.this_config.total || 0
        )


      for (
        let i = 0;
        i < this.fileList.data.length;
        i++
      ) {

        let item =
          this.fileList.data[i]


        if (!item.selected) {

          continue

        }


        /**
         * total > 0
         * 有数量限制
         */
        if (
          maxTotal > 0 &&
          list.length >= maxTotal
        ) {

          break

        }


        list.push({

          file_id:
            item.file_id,

          file_path:
            item.file_path,

          real_name:
            item.real_name

        })

      }


      if (
        list.length === 0
      ) {

        this.$message({
          message: '请选择文件',
          type: 'warning'
        })

        return

      }


      this.$emit(
        'returnImgs',
        list
      )

    },


    /**
     * 取消
     */
    cancelFunc() {

      this.$emit(
        'returnImgs',
        null
      )

    }

  }

}
</script>


<style lang="scss" scoped>

/* =========================================================
   弹窗
========================================================= */

.upload-dialog {

  .el-dialog__body {
    padding: 18px 22px 0;
  }

}


/* =========================================================
   顶部工具栏
========================================================= */

.file-toolbar {

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 14px 16px;

  margin-bottom: 12px;

  background: #f8fafc;

  border: 1px solid #ebeef5;

  border-radius: 8px;

}


.toolbar-left {

  display: flex;

  align-items: center;

  flex-wrap: wrap;

  gap: 8px;

}


.toolbar-right {

  margin-left: auto;

}


.selected-count {

  height: 30px;

  line-height: 30px;

  padding: 0 12px;

  font-size: 13px;

  color: #606266;

  background: #ffffff;

  border: 1px solid #e4e7ed;

  border-radius: 4px;

}


.selected-count span {

  color: #409EFF;

  font-size: 16px;

  font-weight: bold;

  margin: 0 4px;

}


/* =========================================================
   搜索
========================================================= */

.search-bar {

  display: flex;

  align-items: center;

  padding: 12px 16px;

  margin-bottom: 14px;

  background: #fff;

  border: 1px solid #ebeef5;

  border-radius: 8px;

}


.search-item {

  margin-right: 10px;

}


.type-select {

  width: 140px;

}


.search-input {

  width: 240px;

}


/* =========================================================
   文件主体
========================================================= */

.file-container {

  display: flex;

  height: 430px;

  border: 1px solid #e4e7ed;

  border-radius: 8px;

  overflow: hidden;

  background: #fff;

}


/* =========================================================
   分类
========================================================= */

.file-type {

  width: 150px;

  flex-shrink: 0;

  background: #f7f9fc;

  border-right: 1px solid #e4e7ed;

  overflow-y: auto;

}


.category-title {

  height: 44px;

  line-height: 44px;

  padding: 0 16px;

  font-size: 14px;

  font-weight: bold;

  color: #303133;

  border-bottom: 1px solid #ebeef5;

}


.file-type ul {

  margin: 0;

  padding: 8px;

  list-style: none;

}


.category-item {

  position: relative;

  display: flex;

  align-items: center;

  justify-content: space-between;

  min-height: 40px;

  padding: 0 10px;

  margin-bottom: 4px;

  border-radius: 5px;

  color: #606266;

  cursor: pointer;

  transition: all .2s;

}


.category-item:hover {

  background: #ecf5ff;

  color: #409EFF;

}


.category-item.active {

  background: #409EFF;

  color: #fff;

}


.category-name {

  display: flex;

  align-items: center;

  min-width: 0;

}


.category-name i {

  margin-right: 7px;

}


.category-name span {

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

}


.operation {

  display: none;

  align-items: center;

}


.category-item:hover .operation {

  display: flex;

}


.category-item.active .operation {

  color: #fff;

}


.operation i {

  margin-left: 7px;

}


.operation i:hover {

  opacity: .7;

}


/* =========================================================
   文件列表
========================================================= */

.file-content {

  flex: 1;

  overflow-y: auto;

  padding: 14px;

  background: #fff;

}


.file-list {

  margin: 0;

  padding: 0;

  list-style: none;

}


.file-card {

  position: relative;

  float: left;

  width: 120px;

  margin: 0 12px 16px 0;

  overflow: hidden;

  background: #fff;

  border: 2px solid transparent;

  border-radius: 8px;

  cursor: pointer;

  box-sizing: border-box;

  transition: all .2s;

}


.file-card:hover {

  transform: translateY(-2px);

  border-color: #c6e2ff;

  box-shadow: 0 5px 14px rgba(0,0,0,.08);

}


.file-card.selected {

  border-color: #409EFF;

  background: #ecf5ff;

  box-shadow: 0 4px 14px rgba(64,158,255,.18);

}


.file-preview {

  width: 116px;

  height: 116px;

  overflow: hidden;

  background: #f5f7fa;

  border-radius: 6px 6px 0 0;

}


.preview-image {

  width: 100%;

  height: 100%;

}


.preview-video {

  display: block;

  width: 100%;

  height: 100%;

  object-fit: cover;

}


.document-preview {

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  width: 100%;

  height: 100%;

  color: #909399;

}


.document-preview i {

  font-size: 50px;

}


.document-preview span {

  margin-top: 8px;

  font-size: 12px;

  text-transform: uppercase;

}


.image-error {

  display: flex;

  align-items: center;

  justify-content: center;

  width: 100%;

  height: 100%;

  font-size: 40px;

  color: #c0c4cc;

}


/* =========================================================
   文件名
========================================================= */

.file-info {

  padding: 8px 7px;

}


.file-name {

  margin: 0;

  height: 18px;

  line-height: 18px;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

  font-size: 12px;

  color: #606266;

}


/* =========================================================
   已选择
========================================================= */

.selected-icon {

  position: absolute;

  z-index: 5;

  top: 0;

  left: 0;

  width: 28px;

  height: 28px;

  line-height: 26px;

  text-align: center;

  color: #fff;

  background: #409EFF;

  border-radius: 6px 0 10px 0;

}


/* =========================================================
   删除
========================================================= */

.file-actions {

  position: absolute;

  z-index: 6;

  top: 7px;

  right: 7px;

  opacity: 0;

  transition: opacity .2s;

}


.file-card:hover .file-actions {

  opacity: 1;

}


.delete-btn {

  display: flex;

  align-items: center;

  justify-content: center;

  width: 28px;

  height: 28px;

  color: #fff;

  background: rgba(0,0,0,.58);

  border-radius: 50%;

}


.delete-btn:hover {

  background: #f56c6c;

}


/* =========================================================
   加载 / 空数据
========================================================= */

.loading-box,
.empty-box {

  display: flex;

  height: 100%;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  color: #909399;

}


.loading-box i {

  margin-bottom: 10px;

  font-size: 32px;

  color: #409EFF;

}


.empty-icon {

  font-size: 55px;

  color: #dcdfe6;

}


.empty-title {

  margin-top: 12px;

  font-size: 15px;

  color: #606266;

}


.empty-desc {

  margin-top: 6px;

  font-size: 12px;

  color: #c0c4cc;

}


/* =========================================================
   分页
========================================================= */

.pagination-wrap {

  display: flex;

  align-items: center;

  justify-content: space-between;

  padding: 16px 0;

}


.pagination-info {

  font-size: 13px;

  color: #909399;

}


.pagination-info span {

  color: #409EFF;

  font-weight: bold;

}


/* =========================================================
   底部
========================================================= */

.dialog-footer {

  display: flex;

  align-items: center;

  justify-content: space-between;

  width: 100%;

}


.footer-left {

  font-size: 13px;

  color: #606266;

}


.footer-left strong {

  padding: 0 4px;

  color: #409EFF;

  font-size: 16px;

}


.limit-text {

  margin-left: 14px;

  color: #909399;

}


/* =========================================================
   移动菜单
========================================================= */

.move-title {

  padding: 5px 10px 10px;

  font-weight: bold;

  color: #303133;

}


.move-type {

  max-height: 250px;

  overflow-y: auto;

  margin: 0;

  padding: 0;

  list-style: none;

}


.move-type li {

  height: 36px;

  line-height: 36px;

  padding: 0 12px;

  border-radius: 4px;

  cursor: pointer;

}


.move-type li i {

  margin-right: 7px;

  color: #909399;

}


.move-type li:hover {

  color: #409EFF;

  background: #ecf5ff;

}


/* =========================================================
   Element
========================================================= */

>>> .el-input__inner {

  height: 32px;

}


>>> .el-dialog__footer {

  padding-top: 12px;

  border-top: 1px solid #ebeef5;

}

</style>


// WEBPACK FOOTER //
// src/components/file/Upload.vue